const EdVentures = require("../assets/images/exhibitors-logos/EdVentures.png");
const GDSC_DUM = require("../assets/images/exhibitors-logos/GDSC_DUM.png");
const GDSC_cairo = require("../assets/images/exhibitors-logos/GDSC_cairo.png");
const MUfixlogo = require("../assets/images/exhibitors-logos/MUfix-logo.png");
const Porteina = require("../assets/images/exhibitors-logos/Porteina.png");
const STPlogo = require("../assets/images/exhibitors-logos/STP-logo.png");
const Trufla = require("../assets/images/exhibitors-logos/Trufla.png");
const UCASTI = require("../assets/images/exhibitors-logos/UCASTI.png");
const ackoo = require("../assets/images/exhibitors-logos/ackoo.png");
const acpc = require("../assets/images/exhibitors-logos/acpc.png");
const affectiva = require("../assets/images/exhibitors-logos/affectiva.png");
const agolo = require("../assets/images/exhibitors-logos/agolo.png");
const amanleek = require("../assets/images/exhibitors-logos/amanleek.png");
const careem = require("../assets/images/exhibitors-logos/careem.png");
const cegidem = require("../assets/images/exhibitors-logos/cegidem.png");
const circlepay = require("../assets/images/exhibitors-logos/circlepay.png");
const code = require("../assets/images/exhibitors-logos/code.png");
const consoleya = require("../assets/images/exhibitors-logos/consoleya.png");
const contactcars = require("../assets/images/exhibitors-logos/contact-cars.png");
const egfwd = require("../assets/images/exhibitors-logos/egfwd.png");
const gdcg = require("../assets/images/exhibitors-logos/gdcg.png");
const halan = require("../assets/images/exhibitors-logos/halan.png");
const ieeejordan = require("../assets/images/exhibitors-logos/ieee-jordan.png");
const ieeesac = require("../assets/images/exhibitors-logos/ieeesac.png");
const ischoo = require("../assets/images/exhibitors-logos/ischoolpng");
const itida = require("../assets/images/exhibitors-logos/itida.png");
const jumia = require("../assets/images/exhibitors-logos/jumia.png");
const kashier = require("../assets/images/exhibitors-logos/kashier.png");
const meag = require("../assets/images/exhibitors-logos/meag.png");
const mediabots = require("../assets/images/exhibitors-logos/mediabots.png");
const microsoft = require("../assets/images/exhibitors-logos/microsoft.webp");
const milango = require("../assets/images/exhibitors-logos/milango.png");
const mqrlogo = require("../assets/images/exhibitors-logos/mqr-logo.png");
const nasmasr = require("../assets/images/exhibitors-logos/nas-masr.png");
const nestera = require("../assets/images/exhibitors-logos/nestera.png");
const o7 = require("../assets/images/exhibitors-logos/o7.png");
const orange = require("../assets/images/exhibitors-logos/orange.png");
const pixelogic = require("../assets/images/exhibitors-logos/pixelogic.png");
const plugandplay = require("../assets/images/exhibitors-logos/plug-and-play.png");
const pravica = require("../assets/images/exhibitors-logos/pravica.png");
const psut = require("../assets/images/exhibitors-logos/psut.png");
const route = require("../assets/images/exhibitors-logos/route.png");
const sprints = require("../assets/images/exhibitors-logos/sprints.png");
const squadio = require("../assets/images/exhibitors-logos/squadio.png");
const startupfacctory = require("../assets/images/exhibitors-logos/startupfacctory.png");
const talentsarena = require("../assets/images/exhibitors-logos/talents-arena.png");
const tayar = require("../assets/images/exhibitors-logos/tayar.png");
const technelog = require("../assets/images/exhibitors-logos/techne-log.png");
const treyd = require("../assets/images/exhibitors-logos/treyd.png");
const vodafone = require("../assets/images/exhibitors-logos/vodafone.png");
const talabat = require("../assets/images/exhibitors-logos/talabat.png");
const paymob = require("../assets/images/exhibitors-logos/paymob.jpg");
const xvendo = require("../assets/images/exhibitors-logos/xvendo.png");
const contact_auto = require("../assets/images/exhibitors-logos/contact_auto.png");

export const Exhibitors = [
    {
        id: 1,
        name: "Talents arena",
        logo: talentsarena,
        isSponsor: true
    },
    {
        id: 2,
        name: "Talents arena",
        logo: code,
        isSponsor: true
    },
    {
        id: 3,
        name: "Talents arena",
        logo: halan,
        isSponsor: true
    },
    {
        id: 4,
        name: "Talents arena",
        logo: microsoft,
        isSponsor: true
    },
    {
        id: 5,
        name: "Talents arena",
        logo: cegidem,
        isSponsor: true
    },
    {
        id: 6,
        name: "Talents arena",
        logo: psut,
        isSponsor: true
    },
    {
        id: 7,
        name: "Talents arena",
        logo: plugandplay,
        isSponsor: true
    },
    {
        id: 8,
        name: "Talents arena",
        logo: careem,
        isSponsor: true
    },
    {
        id: 50,
        name: "Talents arena",
        logo: vodafone,
        isSponsor: false
    },
    {
        id: 51,
        name: "Talents arena",
        logo: paymob,
        isSponsor: false
    },
    {
        id: 52,
        name: "Talents arena",
        logo: talabat,
        isSponsor: false
    },
    {
        id: 9,
        name: "Talents arena",
        logo: Porteina,
        isSponsor: false
    },
    {
        id: 10,
        name: "Talents arena",
        logo: circlepay,
        isSponsor: false
    },
    {
        id: 11,
        name: "Talents arena",
        logo: jumia,
        isSponsor: false
    },
    {
        id: 12,
        name: "Talents arena",
        logo: pixelogic,
        isSponsor: false
    },
    {
        id: 13,
        name: "Talents arena",
        logo: agolo,
        isSponsor: false
    },
    {
        id: 14,
        name: "Talents arena",
        logo: Trufla,
        isSponsor: false
    },
    {
        id: 15,
        name: "Talents arena",
        logo: kashier,
        isSponsor: false
    },
    {
        id: 16,
        name: "Talents arena",
        logo: squadio,
        isSponsor: false
    },
    {
        id: 17,
        name: "Talents arena",
        logo: treyd,
        isSponsor: false
    },
    {
        id: 18,
        name: "Talents arena",
        logo: o7,
        isSponsor: false
    },
    {
        id: 19,
        name: "Talents arena",
        logo: amanleek,
        isSponsor: false
    },

    {
        id: 53,
        name: "Talents arena",
        logo: xvendo,
        isSponsor: false
    },
    {
        id: 54,
        name: "Talents arena",
        logo: contact_auto,
        isSponsor: false
    },
    {
        id: 20,
        name: "Talents arena",
        logo: affectiva,
        isSponsor: false
    },
    {
        id: 21,
        name: "Talents arena",
        logo: ackoo,
        isSponsor: false
    },
    {
        id: 22,
        name: "Talents arena",
        logo: contactcars,
        isSponsor: false
    },
    {
        id: 23,
        name: "Talents arena",
        logo: milango,
        isSponsor: false
    },
    {
        id: 24,
        name: "Talents arena",
        logo: sprints,
        isSponsor: false
    },
    {
        id: 25,
        name: "Talents arena",
        logo: pravica,
        isSponsor: false
    },
    {
        id: 26,
        name: "Talents arena",
        logo: orange,
        isSponsor: false
    },
    {
        id: 27,
        name: "Talents arena",
        logo: tayar,
        isSponsor: false
    },
    {
        id: 28,
        name: "Talents arena",
        logo: nestera,
        isSponsor: false
    },
    {
        id: 29,
        name: "Talents arena",
        logo: mediabots,
        isSponsor: false
    },
    {
        id: 30,
        name: "Talents arena",
        logo: ischoo,
        isSponsor: false
    },
    {
        id: 31,
        name: "Talents arena",
        logo: nasmasr,
        isSponsor: false
    },
    {
        id: 32,
        name: "Talents arena",
        logo: acpc,
        isSponsor: false
    },
    {
        id: 33,
        name: "Talents arena",
        logo: itida,
        isSponsor: false
    },
    {
        id: 34,
        name: "Talents arena",
        logo: EdVentures,
        isSponsor: false
    },
    {
        id: 35,
        name: "Talents arena",
        logo: route,
        isSponsor: false
    },
    {
        id: 36,
        name: "Talents arena",
        logo: egfwd,
        isSponsor: false
    },
    {
        id: 37,
        name: "Talents arena",
        logo: consoleya,
        isSponsor: false
    },
    {
        id: 38,
        name: "Talents arena",
        logo: technelog,
        isSponsor: false
    },
    {
        id: 39,
        name: "Talents arena",
        logo: ieeesac,
        isSponsor: false
    },
    {
        id: 40,
        name: "Talents arena",
        logo: mqrlogo,
        isSponsor: false
    },
    {
        id: 41,
        name: "Talents arena",
        logo: startupfacctory,
        isSponsor: false
    },
    {
        id: 42,
        name: "Talents arena",
        logo: UCASTI,
        isSponsor: false
    },
    {
        id: 43,
        name: "Talents arena",
        logo: ieeejordan,
        isSponsor: false
    },
    {
        id: 44,
        name: "Talents arena",
        logo: GDSC_cairo,
        isSponsor: false
    },
    {
        id: 45,
        name: "Talents arena",
        logo: GDSC_DUM,
        isSponsor: false
    },
    {
        id: 46,
        name: "Talents arena",
        logo: gdcg,
        isSponsor: false
    },
    {
        id: 47,
        name: "Talents arena",
        logo: MUfixlogo,
        isSponsor: false
    },
    {
        id: 48,
        name: "Talents arena",
        logo: meag,
        isSponsor: false
    },
    {
        id: 49,
        name: "Talents arena",
        logo: STPlogo,
        isSponsor: false
    }
];
